export const API_ERROR = "api_failed";

export const SELECT_CHANGEVALUE = "igp_Select_ChangeValue";

export const PO_LIST = "igp_po_list";
export const PO_LIST_SUCCESS = "igp_po_list_success";

export const ADD_PO_DATA = "igp_add_po_data";
export const INPUT_CHANGEVALUE = "igp_input_ChangeValue";
export const IGP_INPUT_CHANGEVALUE = "igp_home_input_ChangeValue";

export const IGP_ADD = "igp_add";
export const IGP_ITEM_SELECT = "IGP_item_select";

export const IGP_LIST = "IGP_list";
export const IGP_LIST_SUCCESS = "IGP_list_success";

export const PREVIEW_IMAGE = "igp_preview_image";

export const UPLOAD_IGP_IMAGE = "igp_upload_igp_image";
export const UPLOAD_IGP_IMAGE_SUCCESS = "igp_upload_igp_image_success";

export const UPLOAD_IMAGE = "IGP_UPLOAD_IMAGE";
export const UPLOAD_IMAGE_SUCCESS = "IGP_UPLOAD_IMAGE_SUCCESS";

export const TOGGLE_ITEM_MENU = "q_toggle_item_menu";

export const SET_PARAMS = "Q_set_params";
export const FILTER_INPUT_CHANGEVALUE = "pi_Filter_input_ChangeValue";
export const FILTER_SELECT_CHANGEVALUE = "pi_Filter_Select_ChangeValue";

export const IGP_ROW_DATA = "IGP_row_data";
export const IGP_ROW_DATA_SUCCESS = "IGP_row_data_success";
export const LIST_LAYOUT = "IGP_list_layout";

export const PO_ITEM_LIST = "IGP_po_item_list";
export const PO_ITEM_LIST_SUCCESS = "IGP_po_item_list_success";

export const FILTERS_SHOW_RIGHT_SIDEBAR = "IGP_filter_show_right_sidebar";
export const FILTERS_HIDE_RIGHT_SIDEBAR = "IGP_filter_hide_right_sidebar";
export const CLEAR_FILTER = "IGP_clear_filter";

export const ITEM_QTY_CHANGEVALUE = "IGP_item_qty_chanagevaluer";
export const ITEM_UNITES_CHANGEVALUE = "IGP_item_unites_chanagevaluer";

export const PO_ITEM_MODEL_CLOSE = "IGP_po_item_model_close";
export const IGP_ADD_PO_DATA = "IGP_add_po_data";

export const IGP_PO_DATA_REMOVE = "IGP_po_data_remove";
